import React from 'react'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'

import Alert from 'util/modules/Alert'
import PanelLayout from 'panel/_root/Layout'

import SignIn from 'panel/user/sign-on/SignIn'
import SignUp from 'panel/user/sign-on/SignUp'
import Recovery from 'panel/user/recovery/Recovery'

const AppRouter: React.FC = () => {
  return (
    <>
      <Alert />
      <Router>
        <Route exact path="/" render={(): any => <Redirect to="/panel/partner" />} />
        <Route path="/panel" component={PanelLayout }/>

        <Route exact path="/sign-in" component={SignIn} />
        <Route exact path="/sign-up" component={SignUp} />
        <Route exact path="/recovery" component={Recovery} />
      </Router>
    </>
  )
}

export default AppRouter
